import React from "react";
import "../styles/skeleton.css";

const Skl: React.FC<{ className?: string; style?: React.CSSProperties }> = ({
  className = "",
  style,
}) => <div className={`skeleton ${className}`} style={style} />;

const PropertyCardSkeleton: React.FC = () => (
  <div className="card h-100 border rounded-3 overflow-hidden shadow-sm bg-white">
    <div
      className="skeleton"
      style={{
        height: "210px",
        width: "100%",
        borderRadius: 0,
        animationDelay: "0s",
      }}
    />

    <div className="card-body p-4 d-flex flex-column justify-content-between">
      <div>
        <Skl
          style={{ width: "80px", height: "12px", marginBottom: "8px" }}
        />

        <Skl
          style={{ width: "75%", height: "18px", marginBottom: "8px" }}
        />

        <Skl
          style={{ width: "55%", height: "14px", marginBottom: "16px" }}
        />

        <div className="row g-2 py-3 border-top border-bottom my-3 row-cols-2">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="col d-flex align-items-center gap-2"
            >
              <Skl
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  flexShrink: 0,
                }}
              />
              <Skl style={{ width: "70%", height: "12px" }} />
            </div>
          ))}
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between mt-2 pt-1">
        <div style={{ width: "100%" }}>
          <Skl
            style={{
              width: "50px",
              height: "10px",
              marginBottom: "6px",
            }}
          />
          <Skl style={{ width: "60%", height: "24px" }} />
        </div>
      </div>
    </div>
  </div>
);

export default PropertyCardSkeleton;
